const siteUrl = import.meta.env.VITE_SITE_URL || import.meta.env.VITE_APP_URL || window.location.origin;

const config = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  MEDIA_BASE_URL: import.meta.env.VITE_MEDIA_URL || siteUrl,
  SITE_URL: siteUrl,
  CONTACT_PHONE: '02188315658',  // شماره تماس پیش‌فرض سایت
  CONTACT_WHATSAPP: '989124948703', // شماره واتساپ (بدون 0)
  getMediaUrl: (path) => {
    if (!path) return '/placeholder-product.jpg';
    if (path.startsWith('http')) return path;
    return `${config.MEDIA_BASE_URL}${path}`;
  },

  getApiUrl: (endpoint) => {
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${config.API_BASE_URL}${cleanEndpoint}`;
  },

};
export default config;
